var exports = {
  "lm": "LanguageTab.module__notice___THJFcG",
  "ut": "LanguageTab.module__noticeText___THJFcG",
  "nf": "LanguageTab.module__link___THJFcG",
  "XG": "LanguageTab.module__languageSelect___THJFcG",
  "pK": "LanguageTab.module__languageControls___THJFcG",
  "e5": "LanguageTab.module__timeControls___THJFcG",
  "_9": "LanguageTab.module__languageOption___THJFcG",
  "Ri": "LanguageTab.module__languageOptionMenu___THJFcG",
  "l5": "LanguageTab.module__languageDetails___THJFcG",
  "aX": "LanguageTab.module__languageCode___THJFcG",
  "Eb": "LanguageTab.module__flagImage___THJFcG",
  "TU": "LanguageTab.module__flagImageText___THJFcG",
  "hx": "LanguageTab.module__languageOptionCompact___THJFcG",
  "cL": "LanguageTab.module__languageName___THJFcG",
  "X6": "LanguageTab.module__languageOptionSelected___THJFcG",
  "rv": "LanguageTab.module__tooltipContent___THJFcG",
  "HE": "LanguageTab.module__tooltipText___THJFcG",
  "QT": "LanguageTab.module__switchWrapper___THJFcG",
  "Kx": "LanguageTab.module__spellcheckHint___THJFcG",
  "OO": "LanguageTab.module__spellcheckRestartBanner___THJFcG",
  "Ru": "LanguageTab.module__dictionaryGrid___THJFcG",
  "b": "LanguageTab.module__dictionaryRow___THJFcG",
  "CG": "LanguageTab.module__dictionaryRowChecked___THJFcG",
  "mj": "LanguageTab.module__dictionaryName___THJFcG",
  "P": "LanguageTab.module__dictionaryTag___THJFcG",
  "Wc": "LanguageTab.module__manualDictionaryBlock___THJFcG",
  "uW": "LanguageTab.module__personalDictAddRow___THJFcG",
  "bU": "LanguageTab.module__personalDictInput___THJFcG",
  "rj": "LanguageTab.module__personalDictList___THJFcG",
  "ze": "LanguageTab.module__personalDictChip___THJFcG",
  "nm": "LanguageTab.module__personalDictChipRemove___THJFcG",
  "ib": "LanguageTab.module__personalDictEmpty___THJFcG",
};

module.exports = exports;
